import type { WorkspaceItem } from '@/services/workspace';

/**
 * Where a saved item leads. Only CADE has a case page and a decision search that
 * accept these keys today; an item for another agency still lists, without a
 * link, rather than pointing at a route that does not exist.
 */
export function workspaceHref(item: WorkspaceItem): string | null {
  if (item.agency !== 'cade') return null;
  if (item.kind === 'case') {
    const digits = item.key.replace(/\D/g, '');
    return digits ? `/cade/c/${digits}` : null;
  }
  return `/cade/decisions?${item.key}`;
}
